function handleCookiePopup() {
  var gtmCookie = document.querySelector('.nb--cookiepopup[data-nbcookie="gtmcookie"]')

  if (gtmCookie) {
    var popupCookie = Cookies.get('gtmCookiePopup')

    var radioButtons = document.querySelectorAll('.nb--cookiepopup__field--radio input')
    var requiredDiv = document.querySelector('.nb--cookiepopup__required')

    var settingsButtons = document.getElementsByClassName('js--nb-cookie-settings')
    var introDiv = document.querySelector('.nb--cookiepopup__intro')
    var settingsDiv = document.querySelector('.nb--cookiepopup__settings')
    var minimalRadio = document.querySelector('input[name=nbcookie][value=minimal]')
    var optimalRadio = document.querySelector('input[name=nbcookie][value=optimal]')

    var buttons = document.getElementsByClassName('js--nb-gtmcookie')

    for (let i = 0; i < radioButtons.length; i++) {
      const el = radioButtons[i]
      el.addEventListener('change', hideRequiredDiv)
    }

    for (let i = 0; i < settingsButtons.length; i++) {
      const el = settingsButtons[i]
      el.addEventListener('click', handleChangeSettings)
    }

    for (let i = 0; i < buttons.length; i++) {
      const el = buttons[i]
      el.addEventListener('click', handleButton)
    }

    function hideRequiredDiv() {
      requiredDiv.style.display = 'none'
    }

    function showRequiredDiv() {
      requiredDiv.style.display = 'block'
    }

    function init() {
      if (!popupCookie) {
        gtmCookie.setAttribute('data-nbcookiestate', 'active')
      }
    }

    function handleChangeSettings(e) {
      e.preventDefault()

      gtmCookie.setAttribute('data-nbcookiestate', 'active')

      showSettingsTab()

      if (minimalRadio && optimalRadio) {
        if (popupCookie === 0) {
          minimalRadio.checked = true
        } else if (popupCookie === 1) {
          optimalRadio.checked = true
        }
      }
    }

    function handleButton(e) {
      e.preventDefault()

      var answer = this.getAttribute('data-answer')

      Cookies.remove('gtmCookieAccepted')

      if (answer === 'accept') {
        nbCookieAccepted()
      } else if (answer === 'declined') {
        nbCookieDeclined()
      } else if (answer === 'settings') {
        showSettingsTab()
      } else if (answer === 'radio') {
        var checkedRadio = document.querySelector('input[type=radio][name=nbcookie]:checked')

        if (checkedRadio) {
          checkedRadio.value === 'optimal' ? nbCookieAccepted() : nbCookieDeclined()
        } else {
          showRequiredDiv()
        }
      } else {
        nbCookieDeclined()
      }
    }

    function showSettingsTab() {
      if (!settingsDiv) return

      introDiv.style.display = 'none'
      settingsDiv.style.display = 'block'
    }

    function nbCookieAccepted() {
      Cookies.set('gtmCookieAccepted', 2, { expires: 1095 })
      Cookies.set('gtmCookiePopup', 1, { expires: 1095 })

      location.reload()
    }

    function nbCookieDeclined() {
      Cookies.set('gtmCookieAccepted', 1, { expires: 1095 })
      Cookies.set('gtmCookiePopup', 1, { expires: 1095 })

      location.reload()
    }

    init()
  }
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  // call on next available tick
  setTimeout(handleCookiePopup, 1)
} else {
  document.addEventListener('DOMContentLoaded', handleCookiePopup)
}
